var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saveButton"},[_c('b-button',_vm._b({attrs:{"type":"is-primary","label":_vm.$t('button.save')},on:{"click":function () { return this$1.$emit('click'); }}},'b-button',Object.assign({}, _vm.$props, _vm.$attrs),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }